export default "__VITE_ASSET__CJLXDx20__"